import React from "react";
import Link from "../link/component";
interface TableOfContentsProps {
  items: string;
}

import { container, item_list } from "./styles.module.scss";
import { parameterize } from "../../utils";

const TableOfContents: React.FC<TableOfContentsProps> = ({ items }) => {
  const splitAndFormatString = (input) => {
    return input.split(", ").map((item) => {
      return item;
    });
  };

  const itemsArray = splitAndFormatString(items);

  return (
    <div className={container}>
      <h2>Table of Contents</h2>
      <ul className={item_list}>
        {itemsArray.map((item, index) => (
          <li key={index}>
            <Link to={`#${parameterize(item)}`}>{item}</Link>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default TableOfContents;
